module.exports = __webpack_public_path__ + "fonts/AvertaStd-Bold.woff2";